import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const validate = (data) => {
  const errors = {};

  if (!data.username) {
    errors.username = {
      message: 'Please enter a username',
    };
  }

  if (!data.password) {
    errors.password = {
      message: 'Please enter a password',
    };
  }

  return errors;
};

export default class BookerAuthorize extends Component {
  constructor() {
    super();

    this.state = {
      username: '',
      password: '',
      errors: {},
    };

    this.onSubmit = this.onSubmit.bind(this);
    //this.onSkip = this.onSkip.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }


  onSubmit() {
    const data = {
      username: this.state.username,
      password: this.state.password,
    };

    const validationErrors = validate(data);

    if (Object.keys(validationErrors).length) {
      this.setState({
        errors: validationErrors,
        mandatoryFieldError: true,
      });
    } else {
      this.setState(
        {
          errors: {},
          mandatoryFieldError: false,
        },
        () => {
          this.props.postStaffLogin(data);
        },
      );
    }
  }
  
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  render() {
    const { dashboard, softwares, onBack , onSkip} = this.props;
    const { username, password, mandatoryFieldError, errors } = this.state;
    const isSwConnected = false; 
    // dashboard.tasksStatus.bookingSW_connect === 'completed';

    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.staffCredentialsSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Failed to save staff credentials
            </p>
          ) : null}
          <section className="authorize-access__sw-details">
            <p className="authorize-access__heading">
              Please create a staff login on your Restore software for TrueLark to use and enter
              those here
            </p>
            <div className="authorize-access__form__row form-group">
              <p className="form-group__heading">Username</p>
              <input
                type="text"
                name="username"
                className={classnames({
                  'has-error': errors.username,
                })}
                value={username}
                onChange={this.handleChange}
                autoComplete="false"
                placeholder="Username"
                disabled={isSwConnected}
              />
            </div>

            <div className="authorize-access__form__row form-group">
              <p className="form-group__heading">Password</p>
              <input
                type="text"
                name="password"
                className={classnames({
                  'has-error': errors.password,
                })}
                value={password}
                onChange={this.handleChange}
                autoComplete="false"
                placeholder="password"
                disabled={isSwConnected}
              />
            </div>
          </section>
        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={onBack}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onSubmit}
            disabled={softwares.isSavingStaffCredentials}
          >
            {!softwares.isSavingStaffCredentials ? 'Next' : 'Saving...'}
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={()=>this.props.postStaffLogin({skip:true})}
          >
            SKIP
          </button>

        </div>
      </div>
    );
  }
}

BookerAuthorize.propTypes = {
  onBack: PropTypes.func.isRequired,
  postStaffLogin: PropTypes.func.isRequired,
  dashboard: PropTypes.shape().isRequired,
  softwares: PropTypes.shape().isRequired,
};
